import React from 'react';
import './App.css';
import Homepage from './Components/Homepage/Homepage';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Menu from 'FoodPage/Menu';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/food" element={<Menu />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;